module.exports = __webpack_public_path__ + "static/img/5.2b61368.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/5.png
// module id = 3tm1
// module chunks = 5